export default "__VITE_ASSET__BjhrI7mK__"